module.exports = __webpack_public_path__ + "img/banner-bg.3bcf3998.jpg";